import { Link, Text } from '@change/ds-core-ui/next';

import { PetitionUpdateActions } from './components/PetitionUpdateActions';
import { PetitionUpdateByLine } from './components/PetitionUpdateByLine';
import { PetitionUpdateMedia } from './components/PetitionUpdateMedia';
import { usePageHeading } from './hooks/usePageHeading';

export function PageHeading() {
	const {
		data: { title, type, petitionTitle, petitionUrl },
	} = usePageHeading();

	return (
		<div className="flex flex-col gap-6 md:gap-12">
			<div className="flex flex-col gap-4">
				<Text variant="heading" size="xx-small" data-qa="petition-update-type">
					{type}
				</Text>
				<Link href={petitionUrl} data-qa="petition-title-link" size="small">
					{petitionTitle}
				</Link>
				<Text variant="heading" size="x-large" data-qa="petition-update-title">
					{title}
				</Text>
			</div>
			<PetitionUpdateActions />
			<PetitionUpdateByLine />
			<PetitionUpdateMedia />
		</div>
	);
}
